"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "body1StrongerClassNames", {
    enumerable: true,
    get: function() {
        return _useBody1StrongerStylesstyles.body1StrongerClassNames;
    }
});
const _export_star = require("@swc/helpers/_/_export_star");
_export_star._(require("./Body1Stronger"), exports);
const _useBody1StrongerStylesstyles = require("./useBody1StrongerStyles.styles");
